

export const columns = [
    {
        type: 'index',
        width: 65,
        title: '序号'
    },
    {
        title: '车牌号',
        key: 'number',
        minWidth: 160,
        show: true
    },
    {
        title: '品牌',
        key: 'brand',
        minWidth: 160,
        show: true
    },
    {
        title: '车型',
        key: 'type',
        minWidth: 100,
        show: true
    },
    {
        title: '颜色',
        key: 'color',
        minWidth: 100,
        show: true
    },
    {
        title: '当前里程',
        key: 'currentMileage',
        minWidth: 100,
        show: true
    },
    {
        title: '状态',
        slot: 'useState',
        minWidth: 100,
        maxWidth: 100,
        show: true
    },
    {
        title: '创建时间',
        slot: 'createdTime',
        minWidth: 180,
        maxWidth: 180,
        show: true
    },
    {
        title: '操作',
        slot: 'action',
        minWidth: 145,
        maxWidth: 145,
        show: true
    },
]

